/**
 * Determine whether a regular expression contains a matching group
 *
 * The function uses a string as an input. To check actual RegExp instance,
 * use hasRegExpMatchingGroups(regExpInstance.source).
 * Invalid regexes are assumed to not have matching groups for simplicity.
 */
export const hasRegExpMatchingGroups = (regexp: string): boolean => {
  try {
    // Make the regexp match empty string, then execute it against one
    // and check if the regex return more than the root match.
    return new RegExp(`${regexp}|`).exec('')!.length > 1;
  } catch {
    return false;
  }
};
